import { render, staticRenderFns } from "./ReceiptReport.vue?vue&type=template&id=99246f64&scoped=true"
import script from "./ReceiptReport.vue?vue&type=script&lang=js"
export * from "./ReceiptReport.vue?vue&type=script&lang=js"
import style0 from "./ReceiptReport.vue?vue&type=style&index=0&id=99246f64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99246f64",
  null
  
)

export default component.exports